import { ChatTextIcon } from '@phosphor-icons/react'

import { Card, Skeleton } from '@reveni-io/reveni-ui'

import { statisticSizes } from '@/common/components/Statistic/constants'
import Statistic from '@/common/components/Statistic/Statistic'

import * as Styles from './styles'

const ReasonSummaryHeaderSkeleton = ({ showExchanges }) => {
  const statsCount = showExchanges ? 3 : 1

  return (
    <Card>
      <Styles.Container aria-busy="true">
        <Styles.Summary>
          <Styles.TitleContainer>
            <Skeleton variant="text" width={240} height={28} />
            <Skeleton variant="text" width={160} height={16} />
          </Styles.TitleContainer>
          <Skeleton variant="rounded" width="100%" height={28} />
        </Styles.Summary>
        <Styles.Stats>
          {Array.from({ length: statsCount }).map((_, index) => (
            <Statistic key={index} size={statisticSizes.small} isOutlined={false} Icon={ChatTextIcon} caption loading />
          ))}
        </Styles.Stats>
      </Styles.Container>
    </Card>
  )
}

export default ReasonSummaryHeaderSkeleton
